import Toggle from './Toggle';
import { ToggleProps, ToggleValueProps } from './types';

export type { ToggleProps, ToggleValueProps };
export default Toggle;
